import { NgForOf, NgIf } from '@angular/common';
import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { CheckboxModule } from "primeng/checkbox";
import { InputTextModule } from "primeng/inputtext";
import { PasswordModule } from "primeng/password";
import { FormBuilder, FormControl, FormGroup, ReactiveFormsModule, Validators } from "@angular/forms";
import { DropdownModule } from "primeng/dropdown";
import { CalendarModule } from "primeng/calendar";
import { FileUploadModule, FileUpload } from "primeng/fileupload";
import { ToastModule } from "primeng/toast";
import { MessageService } from "primeng/api";
import { IQueryFormat } from '../enums/types';
import { IBanks, IBanks_P, IBanks_S } from '../interfaces/IBanks';
import { BankService } from '../service/bank.service';
import { PaymentModeService } from "../service/paymentMode.service";
import { PaymentTypeService } from "../service/paymentType.service";
import { NotificationService } from "../service/notification.service";
import { IPaymentReciepts } from "../interfaces/IPaymentReciepts";
import { AuthService } from "../service/auth.service";
import { environment } from "../../environments/environment";
import { UserService } from "../service/user.service";
import { PaymentLogsService } from "../service/paymentLogs.service";
import * as _ from 'lodash';

declare let moment: any;

@Component({
    selector: 'app-payment',
    standalone: true,
    imports: [CheckboxModule, InputTextModule, PasswordModule, ReactiveFormsModule, DropdownModule, CalendarModule, FileUploadModule, ToastModule, NgIf, NgForOf],
    providers: [MessageService],
    templateUrl: './payment.component.html',
    styleUrls: ['./payment.component.scss']
})
export class PaymentComponent implements OnInit {
    addPaymentForm: FormGroup | any;
    paymentMode: any;
    paymentType: any;
    loading = { form: false };
    filteredPaymentMode: any[] = [];
    filteredPaymentType: any[] = [];

    randomString: string | undefined;
    docsFiles: any = [];
    isPdfFileSize2MB: boolean = false;

    @ViewChild('fileUpload') fileUploadRef!: FileUpload;

    today = moment().startOf('day').toDate();
    endDay = moment().endOf('day').toDate();
    selectedDate: Date = new Date();
    bankList: IBanks[] = [];
    fileUrl = environment.FILE_URL;
    imgFileUrl: string = '';
    isImg: boolean = false;

    constructor(private fb: FormBuilder,
                private paymentModeService: PaymentModeService,
                private paymentTypeService: PaymentTypeService,
                private paymentLogsService: PaymentLogsService,
                private ns: NotificationService,
                private userService: UserService,
                private authService: AuthService,
                private bankService: BankService,
                private cd: ChangeDetectorRef,) {
    }

    async ngOnInit() {
        // this.today.setHours(0, 0, 0, 0);
        this.createForm();
        await this.getPaymentMode();
        await this.getPaymentType();
        await this.loadBankList();
    }

    createForm() {
        this.addPaymentForm = this.fb.group({
            mpl_paymentCreditDebitAmount_num: ['', Validators.required],
            mpl_paymentType_objid: ['', Validators.required],
            mpl_paymentMode_objid: ['', Validators.required],
            mpl_paymentDate_dt: new FormControl<Date | null>(new Date()),
            mpl_payRecieptImg_arr: this.fb.control([], Validators.required),
            mpl_paymentStatus_str: "CREDIT"
        });
        // Payment Type changes
        // this.addPaymentForm.get('mpl_paymentType_objid')?.valueChanges.subscribe((typeId: string) => {
        //     this.onPaymentTypeChange(typeId);
        // });

        this.addPaymentForm.get('mpl_paymentMode_objid')?.valueChanges.subscribe((modeId: string) => {
            this.onPaymentModeChange(modeId);
        });
    }

    onPaymentModeChange(modeId: string) {
        const selectedMode = this.paymentMode.find((pm: any) => pm._id === modeId);
        if (selectedMode) {
            this.filteredPaymentType = this.paymentType.filter((pt: any) =>
                pt.paymentMode_objid.includes(modeId)
            );
            const currentType = this.addPaymentForm.get('mpl_paymentType_objid')?.value;
            if (!this.filteredPaymentType.some((pt: any) => pt._id === currentType)) {
                this.addPaymentForm.get('mpl_paymentType_objid')?.reset();
            }
        } else {
            this.filteredPaymentType = [];
            this.addPaymentForm.get('mpl_paymentType_objid')?.reset();
        }
    }

    // onPaymentTypeChange(typeId: string) {
    //     const selectedType = this.paymentType.find((pt: { _id: string; }) => pt._id === typeId);
    //     if (selectedType) {
    //         this.filteredPaymentMode = this.paymentMode.filter((pm: { _id: any; }) =>
    //             selectedType.paymentMode_objid.includes(pm._id)
    //         );
    //         const currentMode = this.addPaymentForm.get('mpl_paymentMode_objid')?.value;
    //         if (!selectedType.paymentMode_objid.includes(currentMode)) this.addPaymentForm.get('mpl_paymentMode_objid')?.reset();
    //     } else {
    //         this.filteredPaymentMode = [];
    //         this.addPaymentForm.get('mpl_paymentMode_objid')?.reset();
    //     }
    // }

    async savePayment() {
        if (this.addPaymentForm.valid) {
            let resp = await this.fileUpload(this.docsFiles[0]);
            const formData: IPaymentReciepts = this.addPaymentForm.value;
            formData.createdAt = new Date();
            formData.active = true;
            formData.mpl_isApprove_bl = false;
            formData.mpl_customer_objid = this.authService.gUser._id;
            formData.mpl_payRecieptImg_arr = resp;
            formData.mpl_paymentStatus_str = 'CREDIT';
            try {
                this.loading.form = true;
                // let res = await this.paymentService.post(formData);
                let resFromLogs = await this.paymentLogsService.post(formData);

                if (resFromLogs) {
                    this.ns.showSuccess('Add payment request send successfully.');
                    this.addPaymentForm.reset();
                    this.addPaymentForm.get('mpl_paymentDate_dt').patchValue(new Date());
                    this.fileUploadRef.clear();
                }
            } catch (e: any) {
                this.ns.showErrorFromResponse(e.error || e, 'Failed to submit review.');
            } finally {
                this.loading.form = false;
                this.cd.detectChanges();
            }
        } else {
            console.log("Form is invalid");
        }
    }

    onUpload(event: any) {
        this.docsFiles = [];
        const files: File[] = event.files; // ✅ use event.files (not event.target.files)
        if (!files.length) return;

        const file = files[0];
        const fileName = file.name.toLowerCase();
        const fileType = file.type;
        // ✅ Check file type (by extension and MIME)
        const isValidType =
            (fileType === 'image/jpeg' || fileType === 'image/png') ||
            (fileName.endsWith('.jpg') || fileName.endsWith('.jpeg') || fileName.endsWith('.png'));

        if (!isValidType) {
            this.ns.showError('Only JPG and PNG files are allowed.');
            return;
        }

        let mb = (files[0].size / 1024) / 1024;
        if (mb > 2) {
            this.isPdfFileSize2MB = true;
            return this.ns.showError(`File should be less than 2 MB`);
        } else {
            this.isPdfFileSize2MB = false;
        }

        this.docsFiles.push(files[0]);

        this.randomString = Math.random().toString().substring(2);
        this.addPaymentForm.get('mpl_payRecieptImg_arr')?.setValue([
            {
                originalName: files[0].name,
                uploadPath: `${environment.FILE_PATH}${environment.PAYMENT_RECEIPTS}/${this.randomString}___${files[0].name}`
            }
        ]);
    }

    async fileUpload(file: File) {
        if (file) {
            const formData = new FormData();
            formData.append('bucketName', environment.BUCKET_NAME);
            formData.append('files', file);
            try {
                return await this.userService.paymentReceiptsUpload(formData);
            } catch (e: any) {
                this.ns.showErrorFromResponse(e.error || e, `Upload receipt failed.`);
            }
        }
    }

    async getPaymentMode() {
        this.paymentMode = await this.paymentModeService.query({ find: { active: true, }, });
    }

    async getPaymentType() {
        this.paymentType = await this.paymentTypeService.query({ find: { active: true, }, });
    }

    onKeyDownPaymentAmount(event: KeyboardEvent) {
        const invalidKeys = ['e', 'E', '+', '-', '.', '='];

        const allowedKeys = [
            'Backspace', 'Tab', 'ArrowLeft', 'ArrowRight', 'Delete'
        ];

        if (
            invalidKeys.includes(event.key) &&
            !allowedKeys.includes(event.key)
        ) {
            event.preventDefault();
        }
    }

    async loadBankList() {
        this.bankList = [];
        let isGst = !_.isEmpty(this.authService.gUser.usr_gstNumber_str);
        let findQuery = <any>{
            active: true
        };

        if (isGst) {
            findQuery.mbp_isGST_bl = true;
        } else {
            findQuery.$or = [{
                mbp_isGST_bl: <any>{
                    $exists: false,
                }
            }, {
                mbp_isGST_bl: false,
            }];
        }

        let query = <IQueryFormat>{
            find: findQuery,
            select: <IBanks_S>{
                mpb_accountName_str: 1,
                mpb_accountNumber_num: 1,
                mpb_bankName_str: 1,
                mpb_ifsc_str: 1,
                mpb_branch_str: 1,
                mpb_mobileNumber_num: 1,
                mpb_img_arr: 1,
                mbp_isGST_bl: 1,
            },
            // sort: <IBanks_S>{ mpb_accountName_str: 1 },
        };
        let resp = await this.bankService.query(query);
        if (resp && resp.length) {
            let findObj = resp.find((el: IBanks_P) => el?.mpb_img_arr?.length);
            if (findObj && findObj._id) {
                this.isImg = true;
                this.imgFileUrl = `${this.fileUrl}${findObj.mpb_img_arr[0]?.uploadPath}`;
            } else {
                this.isImg = false;
                this.bankList = resp;
            }
        }
        this.cd.detectChanges();
    }
}
